import axios, { AxiosResponse } from 'axios';
import { SendRequestConfig } from './models/sendRequest.model';
import ApplicationDetail from './applicationDetail.service';
import { errorHandler } from './errorHandler.service';
import { addTimestampToUrl } from '../utils/Helper';

const defualtConfig: SendRequestConfig = {
  isShowErrorInInterceptor: { isShowErrorInModal: false },
};

axios.interceptors.response.use((res: AxiosResponse): AxiosResponse => {
  return res.data;
});

class SendRequest {
  private static _instance: SendRequest = new SendRequest();
  private appDetail: ApplicationDetail = ApplicationDetail.instance;

  constructor() {
    if (SendRequest._instance) {
      throw new Error('Use DataService.instance');
    }
    SendRequest._instance = this;
  }

  static get instance(): SendRequest {
    return SendRequest._instance;
  }

  get<R>(
    url: string,
    sendRequestConfig: SendRequestConfig = defualtConfig,
    { headers, isShowErrorInInterceptor }: SendRequestConfig = {
      ...defualtConfig,
      ...sendRequestConfig,
    }
  ): Promise<any> {
    url = addTimestampToUrl(url);
    let accessToken = this.appDetail.getAccessToken() || localStorage.getItem('accessToken') || '';
    let loginToken = localStorage.getItem('loginToken') || '';
    const reqOption = {
      headers: {
        'Content-Type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        accessToken,
        loginToken,
        'X-REF-TOKEN': localStorage.getItem('X-REF-DATA') || undefined,
        ...headers,
      },
    };
    return axios(url, reqOption).catch((error: Error): void => {
      errorHandler(error, url, isShowErrorInInterceptor);
    });
  }

  getExternal<R>(
    url: string,
    sendRequestConfig: SendRequestConfig = defualtConfig,
    { headers, isShowErrorInInterceptor }: SendRequestConfig = {
      ...defualtConfig,
      ...sendRequestConfig,
    }
  ): Promise<any> {
    url = addTimestampToUrl(url);
   
    return axios(url).catch((error: Error): void => {
      errorHandler(error, url, isShowErrorInInterceptor);
    });
  }

  post<T, R>(
    url: string,
    body: T,
    sendRequestConfig: SendRequestConfig = defualtConfig,
    { headers, isShowErrorInInterceptor }: SendRequestConfig = {
      ...defualtConfig,
      ...sendRequestConfig,
    }
  ): Promise<any> {
    body = {
      ...body,
    };
    let accessToken=this.appDetail.getAccessToken() || localStorage.getItem('accessToken') || null;
    let loginToken= localStorage.getItem('loginToken') || null;
    url = addTimestampToUrl(url);
    headers = {
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      accessToken,
      loginToken,
      'X-REF-TOKEN': localStorage.getItem('X-REF-DATA') || undefined,
      ...headers,
    };
    return axios
      .post(url, JSON.stringify(body), { headers })
      .catch((error: Error): void => {
        errorHandler(error, url, isShowErrorInInterceptor);
      });
  }

  patch<T, R>(
    url: string,
    body: T,
    sendRequestConfig: SendRequestConfig = defualtConfig,
    { headers, isShowErrorInInterceptor }: SendRequestConfig = {
      ...defualtConfig,
      ...sendRequestConfig,
    }
  ): Promise<any> {
    body = {
      ...body,
    };
    let accessToken=this.appDetail.getAccessToken() || localStorage.getItem('accessToken') || null;
    url = addTimestampToUrl(url);
    headers = {
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
       accessToken,
       'X-REF-TOKEN': localStorage.getItem('X-REF-DATA') || undefined,
      ...headers,
    };
    return axios
      .patch(url, JSON.stringify(body), { headers })
      .catch((error: Error): void => {
        errorHandler(error, url, isShowErrorInInterceptor);
      });
  }

  delete<T, R>(
    url: string,
    body: T,
    sendRequestConfig: SendRequestConfig = defualtConfig,
    { headers, isShowErrorInInterceptor }: SendRequestConfig = {
      ...defualtConfig,
      ...sendRequestConfig,
    }
  ): Promise<any> {
    body = {
      ...body,
    };
    let accessToken=this.appDetail.getAccessToken() || localStorage.getItem('accessToken') || null;
    url = addTimestampToUrl(url);
    headers = {
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
       accessToken,
       'X-REF-TOKEN': localStorage.getItem('X-REF-DATA') || undefined,
      ...headers,
    };
    return axios
      .delete(url, { headers })
      .catch((error: Error): void => {
        errorHandler(error, url, isShowErrorInInterceptor);
      });
  }

  all<R>(
    xhrArray: (AxiosResponse<R> | Promise<AxiosResponse<R>>)[]
  ): Promise<AxiosResponse<R>[]> {
    return axios.all(xhrArray);
  }
}
export default SendRequest;
